<template>
  <v-app>
    <!-- Hero Section -->
    <v-container fluid class="hero-section primary" style="background: linear-gradient(135deg, #8D4E3C 0%, #6D4C41 100%);">
      <v-container>
        <v-row align="center" justify="center" class="py-8">
          <v-col cols="12" md="8" class="text-center">
            <v-icon size="64" color="white" class="mb-4">mdi-calendar-plus</v-icon>
            <h1 class="display-1 white--text font-weight-bold mb-3">
              Solicitar Nuevo Turno
            </h1>
            <p class="title white--text mb-4">
              Reserve su cita médica de forma rápida y sencilla
            </p>
            <v-chip color="white" class="primary--text" large>
              <v-icon left>mdi-phone</v-icon>
              Consultas: {{ contactInfo.WHATSAPP.DISPLAY }}
            </v-chip>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <!-- Main Content -->
    <v-container class="py-8">
      <!-- Information Card -->
      <v-row class="mb-6">
        <v-col cols="12">
          <v-alert
            type="info"
            border="left"
            colored-border
            class="mb-4"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-3" color="info">mdi-information</v-icon>
              <div>
                <h4>Información Importante</h4>
                <p class="mb-0">
                  Puede consultar al número <strong>{{ contactInfo.WHATSAPP.DISPLAY }}</strong> si el profesional con el que se desea atender trabaja con su obra social.
                </p>
              </div>
            </div>
          </v-alert>
        </v-col>
      </v-row>

      <!-- Doctor Selection -->
      <v-row class="mb-6">
        <v-col cols="12">
          <v-card elevation="2" class="rounded-lg">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-doctor</v-icon>
              Seleccionar Profesional
            </v-card-title>
            <v-card-text class="pa-6">
              <v-select
                v-model="selected"
                :items="nombres"
                item-text="text"
                item-value="value"
                label="Seleccione un médico"
                placeholder="Elija el profesional de su preferencia"
                outlined
                prepend-inner-icon="mdi-account-tie"
                class="doctor-select"
                @input="refreshEvents"
                :loading="loadingDoctors"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No hay médicos disponibles
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Message Display -->
      <v-row v-if="messege!==''" class="mb-6">
        <v-col cols="12">
          <v-alert
            type="warning"
            border="left"
            colored-border
          >
            <h4>{{ messege }}</h4>
          </v-alert>
        </v-col>
      </v-row>

      <!-- Appointments Table -->
      <v-row>
        <v-col cols="12">
          <v-card elevation="2" class="rounded-lg">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-calendar-clock</v-icon>
              Turnos Disponibles
              <v-spacer></v-spacer>
              <v-chip v-if="selected" color="white" class="primary--text">
                {{ selected }}
              </v-chip>
            </v-card-title>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="appointments"
                item-key="id"
                class="modern-table"
                :loading="loadding"
                hide-default-footer
                :server-items-length="totalRows"
                @click:row="confirmarTurnoLista($event)"
                :no-data-text="selected ? 'No hay turnos disponibles para este profesional' : 'Seleccione un médico para ver turnos disponibles'"
                loading-text="Cargando turnos disponibles..."
              >
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    color="primary"
                    small
                    @click="confirmarTurnoLista(item)"
                    class="rounded-lg"
                  >
                    <v-icon left small>mdi-calendar-check</v-icon>
                    Reservar
                  </v-btn>
                </template>
                
                <template v-slot:item.fecha="{ item }">
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2" color="primary">mdi-calendar</v-icon>
                    {{ formatDate(item.fecha) }}
                  </div>
                </template>
                
                <template v-slot:item.hora="{ item }">
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2" color="primary">mdi-clock</v-icon>
                    {{ item.hora }}
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Modern Appointment Dialog -->
    <v-dialog v-model="dialog" persistent max-width="800" class="rounded-lg">
      <v-card class="rounded-lg">
        <!-- Dialog Header -->
        <v-card-title class="primary white--text pa-6">
          <v-icon left color="white" size="28">mdi-calendar-plus</v-icon>
          <span class="text-h5 font-weight-light">{{ titulo }}</span>
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="cerrarDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6">
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            
            <!-- Step 1: Personal Information -->
            <div v-if="step===1">
              <v-alert
                type="info"
                border="left"
                colored-border
                class="mb-6"
              >
                <h4>Datos del Paciente</h4>
                <p class="mb-0">Complete sus datos personales para reservar el turno</p>
              </v-alert>

              <v-row>
                <v-col cols="12" md="6">
                  <ValidationProvider v-slot="{ errors }" rules="required" name="name">
                    <v-text-field
                      v-model="account_info.name"
                      label="Nombre *"
                      placeholder="Ingrese su nombre"
                      outlined
                      prepend-inner-icon="mdi-account"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="6">
                  <ValidationProvider v-slot="{ errors }" rules="required" name="lastname">
                    <v-text-field
                      v-model="account_info.lastname"
                      label="Apellido *"
                      placeholder="Ingrese su apellido"
                      outlined
                      prepend-inner-icon="mdi-account"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="6">
                  <ValidationProvider v-slot="{ errors }" rules="required" name="dni">
                    <v-text-field
                      v-model="account_info.dni"
                      label="DNI *"
                      placeholder="Número de documento"
                      outlined
                      prepend-inner-icon="mdi-card-account-details"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="6">
                  <ValidationProvider v-slot="{ errors }" rules="required" name="telefono">
                    <v-text-field
                      v-model="account_info.telefono"
                      label="Teléfono *"
                      placeholder="Número de teléfono"
                      outlined
                      prepend-inner-icon="mdi-phone"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12">
                  <ValidationProvider v-slot="{ errors }" rules="required|email" name="mail">
                    <v-text-field
                      v-model="account_id"
                      ref="mail"
                      label="Correo Electrónico *"
                      placeholder="ejemplo@email.com"
                      outlined
                      prepend-inner-icon="mdi-email"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>
            </div>

            <!-- Step 2: WhatsApp Verification -->
            <div v-if="step===2">
              <v-alert
                :type="enviado ? 'success' : 'warning'"
                border="left"
                colored-border
                class="mb-6"
              >
                <h4>Verificación por WhatsApp</h4>
                <p v-if="!enviado" class="mb-0">Para verificar su identidad, enviaremos un código por WhatsApp al número:</p>
                <div class="d-flex align-center mt-2">
                  <v-icon color="success" class="mr-2">mdi-whatsapp</v-icon>
                  <span class="text-h6 font-weight-bold">{{ account_info.telefono }}</span>
                  <v-btn icon small color="primary" @click="prevStep" class="ml-2" title="Editar número">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </div>
                <p v-if="enviado" class="mb-0 mt-2 green--text text--darken-2 font-weight-bold">
                  <v-icon color="success" left small>mdi-check-circle</v-icon>
                  ¡Código enviado! Revise su WhatsApp.
                </p>
              </v-alert>

              <v-row>
                <v-col cols="12">
                  <ValidationProvider v-slot="{ errors }" rules="required" name="codigo">
                    <v-text-field
                      v-model="codigo"
                      label="Código de Verificación *"
                      placeholder="Ingrese el código recibido por WhatsApp"
                      outlined
                      prepend-inner-icon="mdi-message-text"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                  
                  <div v-if="enviado" class="text-center mt-4">
                    <v-chip color="primary" class="white--text">
                      <v-icon left>mdi-timer</v-icon>
                      Tiempo restante: {{ cuentaRegresiva }}
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Step 3: Validation Loading -->
            <div v-if="step===3">
              <v-alert
                type="success"
                border="left"
                colored-border
                class="mb-6"
              >
                <h4>Validando Código</h4>
                <p class="mb-0">Por favor espere mientras validamos su código...</p>
              </v-alert>

              <div class="text-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="64"
                  class="mb-4"
                ></v-progress-circular>
                <p class="body-1">Procesando información...</p>
              </div>
            </div>

          </ValidationObserver>
        </v-card-text>

        <!-- Dialog Actions -->
        <v-card-actions class="pa-6 pt-0">
          <v-spacer></v-spacer>
          
          <v-btn
            outlined
            color="grey"
            @click="cerrarDialog"
            class="mr-3 rounded-lg"
          >
            <v-icon left>mdi-close</v-icon>
            Cancelar
          </v-btn>

          <v-btn
            v-if="step > 1"
            outlined
            color="primary"
            @click="prevStep"
            class="mr-3 rounded-lg"
          >
            <v-icon left>mdi-arrow-left</v-icon>
            Volver
          </v-btn>

          <v-btn
            v-if="step === 1"
            color="primary"
            @click.prevent="validate_crear_cuenta()"
            class="rounded-lg"
            :loading="loading"
          >
            <v-icon left>mdi-calendar-check</v-icon>
            Continuar
          </v-btn>

          <v-btn
            v-else-if="step === 2 && !enviado"
            color="primary"
            @click="sendCode()"
            class="rounded-lg"
            :loading="loading"
          >
            <v-icon left>mdi-send</v-icon>
            Enviar Código
          </v-btn>
          
          <v-btn
            v-else-if="step === 2 && enviado"
            color="success"
            @click="validateCode()"
            class="rounded-lg"
            :loading="loading"
          >
            <v-icon left>mdi-check-circle</v-icon>
            Verificar y Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>
import ModernSelect from './ModernSelect.vue'
import axios from 'axios'
import { getProfesionales, decodeProfesional, getAppointments, decodeEventos, createPerson, sendCode, validateCode } from '@/services/monolito';
import { createAppointmentWithUrl } from '@/services/monolito';
import {convertDateFormat} from "@/services/utils"
import { config } from '@/config'

let utils = require('@/utils')
var dateFormat = require("dateformat")

export default {
  name: "citaspublico",
  components: {
    ModernSelect
  },
  data: function() {
    return {
      enviado: false,
      puedeEnviar: true,
      contador: 120,
      titulo: '',
      codigo : '',
      loadding: false,
      totalRows: 0,
      headers : [
        {text:"Disponible", align:"center", sort: false, value:"start"},
        {text:"",align:"center", sort: false, value:"actions"},
        ],
      step: 1,
      tabs: ['Libres','Confirmados','En sala de espera', 'Terminado'],
      items1: [
         'Calendario','Lista',
      ],
      account_id: "",
      account_info: {
                mail:'',
                gender:'',
                thalamus_server: this.$default_thalamus_server,
                name: "",
                lastname: "",
                password: "" ,
                dni:"",
                roles: ["end_user"],
                dob: "",
                active: true,
                deceased: false,
                street:"",
                subdivision:"",
                insuranse:  "",
                telefono:"",
                robot: false
            },
      goptions: [
              { text: 'Masculino', value: 'm' },
              { text: 'Femenino', value: 'f' }
          ],
      insuranseOptions: [],
      provincias: [],
      evento : {},
      dialog: false,
      dialogo: false,
      selected: null,
      profesional: [],
      datos: '',
      professionalName: '',
      appointments: [],
      appointments_all: [],
      pacientes: [],
      eventos: [],
      nombres: [],
      items:[],
      EXCLUDE_PROFESIONAL: ["NOELANI COLINAS", "NICOLAS DOSSO", "SILVINA DE PEDRO", "MARIA DE LOS ANGELES TERRAGNOLO"],
      DISCLAIMER_PROFESIONAL : ["SILVINA DE PEDRO"],
      messege: '',
      turno: {
        profesional_name : '',
        start : '',
        end : '',
      },      
      
      currentEvents: [],
      loadingDoctors: false,
      loading: false,
      timerInterval: null
    }
  },
  beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },
  created(){
    // Limpiar autenticación previa para evitar enviar tokens inválidos en una página pública
    this.$store.dispatch('clearAuth'); 
    localStorage.removeItem('access_token');
    
    this.getProfesional()
  },
  mounted(){
        
  },
  computed: {
    contactInfo() {
      return config.CONTACT;
    },
    cuentaRegresiva() {
      let minutos = Math.floor(this.contador / 60);
      let segundos = this.contador % 60;
      return `${minutos}:${segundos < 10 ? '0' : ''}${segundos}`;
    }
  },
  methods: {
    async getProfesional() {
        this.profesional = await getProfesionales();
        
        this.nombres = decodeProfesional(this.profesional)
        
    },
    refreshEvents() {
      this.appointments_all = []
      this.getAppointments()
    },
    iniciarContador() {
      let intervalo = setInterval(() => {
        if (this.contador > 0) {
          this.contador--
        } else {
          clearInterval(intervalo)
          this.$refs.boton.disabled = false
        }
      }, 1000)
    },
    formattedRows(){
      return this.appointments.map(item => ({
               
                    //usuario: item.usuario,
                    start: this.convertDateFormat(item.start),
                    nombre: item.nombre,
                  
                    }));

    },
    convertDateFormat(string) {
        var fecha = string.split(' ')
        
        var info = fecha[0].split('-').reverse().join('/');
        return info + " " + fecha[1];
    },
    
    async getAppointments() {
      this.loadding = true
      let citas = []
      let indice
      if (this.selected !=null){
        indice = this.nombres.findIndex(profesional => profesional.value === this.selected);
        
        // Validar que se encontró el profesional
        if (indice !== -1 && this.nombres[indice]) {
          let profesionalName = this.nombres[indice].text || '';
          if (typeof profesionalName === 'string') {
            profesionalName = profesionalName.toUpperCase();
          } else {
             profesionalName = '';
          }
          if (this.EXCLUDE_PROFESIONAL.some(excluded => profesionalName.includes(excluded))) {
            this.messege = "IMPORTANTE: Si usted quiere atenderse con " + profesionalName + ", no saque turno por aqui. Comuniquese por telefono (2914618644) por favor. Gracias"
            this.appointments = [];
            this.totalRows = 0;
            this.loadding = false;
            return;
          } else if (this.DISCLAIMER_PROFESIONAL.some(disclaimer => profesionalName.includes(disclaimer))) {
            this.messege = "IMPORTANTE: El/La doctor/a " + profesionalName + ", no toma nuevos pacientes. Gracias por comprender."
          } else {
            this.messege = ''
          }
        }
      }
      
      // Obtener el ID del profesional seleccionado
      let profesionalId = 0;
      if (this.selected != null) {
        if (indice !== -1 && this.profesional[indice]) {
          profesionalId = this.profesional[indice].id || 0;
        }
      }
      
      let data = await getAppointments(profesionalId);
      
      let json_response = decodeEventos(data)
        
      if (json_response && json_response.citas){
        
        this.appointments = json_response.citas
        this.totalRows = this.appointments.length
        
        this.pacientes = json_response.pacientes
      } else {
        this.appointments = [];
        this.totalRows = 0;
      }
      this.loadding = false
    },
    
    async confirmarTurno(event){
        let url = "/appointments/"
        
        // Enrich event with patient data so createAppointmentWithUrl can send it
        const enrichedEvent = { 
            ...event,
            name: this.account_info.name,
            lastname: this.account_info.lastname,
            telefono: this.account_info.telefono,
            mail: this.account_id // account_id holds the email in this component context
        };

        const response = await createAppointmentWithUrl(url, this.account_info.dni, enrichedEvent)
        if (response === 200){
          let indice = this.nombres.findIndex(profesional => profesional.value === this.selected);
          
          // Validar que se encontró el profesional
          if (indice !== -1 && this.nombres[indice]) {
            // Usar el texto del profesional (ej: "Juan Pérez - Cardiología"), no el ID
            let textoProfesional = this.nombres[indice].text || '';
            let partes = textoProfesional.split(' - ');
            
            this.turno.profesional_name = partes[0].trim() || 'Profesional no disponible';
            
            if (partes.length > 1) {
              this.turno.especialidad = partes[partes.length - 1].trim();
            } else {
              this.turno.especialidad = 'Especialidad no disponible';
            }
          } else {
            this.turno.profesional_name = 'Profesional no disponible'
            this.turno.especialidad = 'Especialidad no disponible'
          }
          
          // Fix: Avoid toLocaleString() for parsing dates as it causes timezone confusion
          // Use original ISO string if available or standard parsing
          this.turno.start = new Date(event.start)
          this.turno.end = new Date(event.end)
         
          this.$store.commit('set_turno', this.turno);
          // redirect to the "Turno" component
          this.$router.replace({ name: "turno" });
        }
        else if(response===423){
          this.$alert({
            title: 'Turno duplicado',
            message: 'Usted ya tiene un turno reservado para el mismo día con este médico. Cualquier duda contáctese vía telefónica.',
            color: 'warning'
          })
        }
        else{
          this.$alert({
            title: 'No se pudo registrar',
            message: 'Hubo un problema al registrar su turno. Contáctese vía telefónica.',
            color: 'error'
          })
        }
    },
    nextStep(reenviar){
      if (!reenviar){
        this.step+=1;
        if (this.step===4) this.closeDialog(false)
      }
    },
    prevStep(){
      if (this.step === 2) {
         this.enviado = false; // Resetear estado si vuelve atrás para corregir teléfono
      }
      this.step-=1;
      if (this.step===0) this.step=1;
    },
    change_step(){
      if (this.step===1){
        this.step = 2
      }
      else if (this.step===2){
        this.step = 3
      }
      else if (this.step===3){
        this.closeDialog(false)
      }
    },
    closeDialog(close){
      this.dialog = close
      this.step = 1
    },
  async confirmarTurnoLista(event){
  if (await this.$confirm({ title: 'Confirmar', message: '¿Está seguro que desea reservar este turno?' })) {
        this.evento = event
        this.dialog = true
        this.step = 1
      }
    },
    async crearCuenta(){
      this.account_info.mail = this.account_id
      try {
        // Intentar crear la persona. Endpoint: POST /people/{email} (ahora público)
        await createPerson(this.account_info.mail, this.account_info)
      } catch (error) {
        // Manejar errores sin bloquear el flujo
        
        if (error.response && error.response.status === 409) {
          // Si ya existe, es el comportamiento esperado para pacientes recurrentes.
        } else if (error.response && error.response.status === 401) {
          // Intentamos continuar de todos modos, quizas createAppointmentWithUrl maneje la asociación por DNI.
        }
      }
      
      this.dialogo = false
      this.nextStep() 
      
      // Auto-enviar código al avanzar al paso de verificación para flujo más fluido
      this.sendCode();
    },
    async validate_crear_cuenta(){
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
            this.dialogo = true
            this.crearCuenta()
        } else {
            // Obtener campos con errores para mensaje detallado
            const errors = this.$refs.observer.errors || {};
            const invalidFields = Object.keys(errors).filter(key => errors[key].length > 0);
            const fieldNames = {
                name: 'Nombre',
                lastname: 'Apellido',
                dni: 'DNI',
                telefono: 'Teléfono',
                mail: 'Correo Electrónico',
                codigo: 'Código de Verificación'
            };
            
            const readableFields = invalidFields.map(f => fieldNames[f] || f).join(', ');
            
            await this.$alert({ 
                title: 'Datos Incompletos', 
                message: `Por favor revise los siguientes campos: ${readableFields}.`, 
                color: 'warning' 
            })
            this.dialogo = false
        }
    },
    validar_cel(telefono){
      if (telefono.length!=10){
        return false
      }
      else{
        return true
      }
    },
    checkRateLimit() {
      // En desarrollo o test, no aplicar rate limiting
      if (process.env.NODE_ENV !== 'production') {
        // ...existing code...
        return true;
      }

      const MAX_ATTEMPTS = 3;
      const BLOCK_DURATION = 2 * 60 * 60 * 1000; // 2 horas en milisegundos
      const now = Date.now();
      
      const blockUntil = localStorage.getItem('sms_block_until');
      if (blockUntil && now < parseInt(blockUntil)) {
        const remainingMinutes = Math.ceil((parseInt(blockUntil) - now) / 60000);
        this.$alert({
          title: 'Envío bloqueado',
          message: `Ha excedido el límite de intentos. Por favor espere ${remainingMinutes} minutos antes de volver a intentar.`,
          color: 'error'
        });
        return false;
      }
      
      // Si ya pasó el tiempo de bloqueo, resetear
      if (blockUntil && now >= parseInt(blockUntil)) {
        localStorage.removeItem('sms_block_until');
        localStorage.setItem('sms_attempts', '0');
      }

      let attempts = parseInt(localStorage.getItem('sms_attempts') || '0');
      if (attempts >= MAX_ATTEMPTS) {
        const newBlockUntil = now + BLOCK_DURATION;
        localStorage.setItem('sms_block_until', newBlockUntil.toString());
        this.$alert({
          title: 'Límite excedido',
          message: 'Ha superado el número máximo de envíos (3). El envío de SMS se ha deshabilitado por 2 horas.',
          color: 'error'
        });
        return false;
      }
      
      return true;
    },
    async sendCode(reenviar){
      if (!this.checkRateLimit()) return;
      
      let tel = this.account_info.telefono
      if (this.validar_cel(tel)){
        tel = "54" + tel
        
        // Incrementar intentos
        let attempts = parseInt(localStorage.getItem('sms_attempts') || '0');
        localStorage.setItem('sms_attempts', (attempts + 1).toString());
        
        let respuesta = await sendCode(this.account_info.dni, tel)
        
        if (respuesta){
          this.enviado = true;
          this.puedeEnviar = false;
          
          // Reiniciar contador
          this.contador = 60;
          if (this.timerInterval) clearInterval(this.timerInterval);
          
          this.timerInterval = setInterval(() => {
            if (this.contador > 0) {
              this.contador--;
            } else {
              clearInterval(this.timerInterval);
              this.puedeEnviar = true;
              this.contador = 60;
              // No reseteamos enviado a false aquí para que el input siga visible? 
              // Si puedeEnviar es true, aparece el boton de "Enviar Codigo" de nuevo?
              // La UI usa "v-if step===2 && !enviado". Si enviado sigue en true, no ve el boton de enviar.
              // El usuario tiene que haber recibido el codigo. Si no, debería poder re-enviar?
              // Si 'enviado' es true, debería haber un boton de "Reenviar"?
              // Por ahora, mantenemos la lógica original pero con el contador arreglado.
            }
          }, 1000);
          
          if (!reenviar) {
             // Iniciar contador si no es reenvío (o reiniciar)
          }
        }
        else{
          this.$alert({ title: 'No se pudo enviar el código', message: 'Verifique el número o intentelo de nuevo más tarde.', color: 'error' })
        }
      }
      else{
        this.$alert({ title: 'Número inválido', message: 'Verifique el número ingresado.', color: 'error' })
      }
    },
    async validateCode(){
      let response = await validateCode(this.account_info.dni, this.codigo)
      if (response){
        this.confirmarTurno(this.evento)
        this.nextStep() //this.change_step();
      }
      else{
        this.$alert({ title: 'Código inválido', message: 'El código ingresado es inválido.', color: 'error' })
      }
    },
    getInitialData(){
            let newJson = []
            let newJson2=[]
              try {
                // Inicializar arrays vacíos para evitar errores
                this.insuranseOptions = []
                this.provincias = []
              } catch (e) { 
                console.error('Error en getInitialData:', e);
              }
              
            return newJson
        },

        // Método para cerrar el dialog
        cerrarDialog() {
          this.dialog = false;
          this.step = 1;
          this.account_info = {
            mail:'',
            gender:'',
            thalamus_server: this.$default_thalamus_server,
            name: "",
            lastname: "",
            password: "" ,
            dni:"",
            roles: ["end_user"],
            dob: "",
            active: true,
            deceased: false,
            street:"",
            subdivision:"",
            insuranse:  "",
            telefono:"",
            robot: false
          };
          this.account_id = "";
          this.codigo = "";
        },

        // Método para formatear fechas
        formatDate(fecha) {
          if (!fecha) return '';
          // Asumiendo que la fecha viene en formato YYYY-MM-DD
          const date = new Date(fecha);
          return date.toLocaleDateString('es-ES', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });
        }
    
  }  
}
</script>

<style lang='css'>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__search,
.style-chooser .vs__selected,
.style-chooser .vs__dropdown-menu {
  border: none;
  text-transform: uppercase;
  font-variant: small-caps;
  text-align: center;
  align-items: center;
}

.style-chooser .vs__fade-enter-active,
.style-chooser .vs__fade-leave-active {
  transition: none;
}
@media screen and (max-width: 500px){
  .style-chooser .vs__search::placeholder,
  .style-chooser .vs__search,
  .style-chooser .vs__selected,
  .style-chooser .vs__dropdown-menu {
    border: none;
    text-transform: uppercase;
    font-variant: small-caps;
    text-align: center;
    font-size: 10px;
  }
}
ul {
  margin: 0;
  padding: 0 0 0 1.5pm;
}
li {
  margin: 0;
  padding: 0;
}

/* Estilos modernos para CitasPublico */
.hero-section {
  min-height: 300px;
}

.modern-table {
  border-radius: 8px !important;
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 8px;
}

.modern-table >>> tbody tr:hover {
  background-color: rgba(141, 78, 60, 0.04) !important;
  cursor: pointer;
}

.modern-table >>> .v-data-table-header {
  background-color: #f5f5f5;
}

.doctor-select >>> .v-input__control {
  border-radius: 8px !important;
}

.rounded-lg {
  border-radius: 12px !important;
}

.v-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.v-card:hover {
  transform: translateY(-2px);
}

.v-btn {
  text-transform: none !important;
  font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .hero-section .display-1 {
    font-size: 2.5rem !important;
  }
  
  .hero-section .title {
    font-size: 1.2rem !important;
  }
}

/* Animation for alerts */
.v-alert {
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>